'use strict';

var $ = require('jquery');

module.exports = function (options) {
	var context = options.context;

	function init() {
		var numbers = context.find('.number');

		$.each(numbers, function (i, element) {
			if (element.innerHTML >= 1000) {
				numbers[i].originalNumber = element.innerHTML;
				numbers[i].innerHTML = element.innerHTML - 1000;
			} else {
				numbers[i].originalNumber = element.innerHTML;
				numbers[i].innerHTML = 0;
			}
		});

		$(window).on('scroll', function () {
			var windowOffset = $(document).scrollTop(),
			    elementOffset = context.offset().top,
			    elementHeight = context.outerHeight(),
			    windowHeight = $(window).outerHeight();

			if (windowOffset >= elementOffset - (windowHeight - elementHeight)) {
				$('.number').each(function () {
					if ($(this)[0].originalNumber !== $(this)[0].innerHtML) {
						$(this).prop('Counter', $(this)[0].innerHTML).animate({
							Counter: $(this)[0].originalNumber
						}, {
							duration: 1000,
							easing: 'swing',
							step: function step(now) {
								$(this).text(Math.ceil(now));
							}
						});
					}
				});
			}
		});
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/hot-stats-counter.js
// module id = 229
// module chunks = 0